(function () {
  function cleanPriceText(node) {
    if (!node || !node.textContent) return;
    var original = node.textContent;
    var cleaned = original
      .replace(/(\$\s?\d[\d,]*)\.00\b/g, '$1')
      .replace(/(\$\s?\d[\d,]*)\.0\b/g, '$1')
      .replace(/(\d[\d,]*)\.00\s?(USD|CAD|AUD|EUR|GBP)\b/g, '$1 $2');
    if (cleaned !== original) node.textContent = cleaned;
  }

  function cleanPrices(root) {
    var scope = root || document;
    scope.querySelectorAll('.price, price-component, product-price, sale-price, compare-at-price, [class*="price" i]').forEach(cleanPriceText);
  }

  document.addEventListener('DOMContentLoaded', function () {
    cleanPrices(document);
    var observer = new MutationObserver(function (records) {
      records.forEach(function (record) {
        if (record.type === 'childList') {
          record.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) cleanPrices(node);
          });
        } else if (record.type === 'characterData' && record.target.parentElement) {
          cleanPriceText(record.target.parentElement);
        }
      });
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  });
})();
